<template>
  <div class="p-2 mb-3 bg-light rounded">
    <div class="filters-header">
      <h4>{{ $t('panel_filtros.titulo') }}</h4>
      <button type="button" class="btn btn-link" @click="clearFilters">{{ $t('panel_filtros.limpiar') }}</button>
    </div>

    <filter-box :title="$t('panel_filtros.texto')" :expanded="true" class="">
      <input class="form-control mt-1" :placeholder="$t('panel_filtros.buscar') + '...'" v-model="filters.searchText">
    </filter-box>

    <filter-box :title="$t('panel_filtros.grupo')" :expanded="!$mqIn(['xs','sm'])">
      <div class="list-group list-group-flush">
        <a href="#" class="list-group-item list-group-item-action" :class="{active:filters.groupsSelected.includes(group.id)}" v-for="group in groupsFirstLevel"
           @click="updateFilter(group.id)">
          {{ group[`title_${locale}`] }}
        </a>
      </div>
    </filter-box>

  </div>
</template>

<script>
    import {LayersService} from "../../commons/services/layersService";
    import FilterBox from "./FilterBox";
    import MediaQueryMixin from "../../commons/mixins/mediaQueryMixin";
    import {ArrayUtils} from "../../commons/utils/arrayUtils";

    export default {
        name: 'FiltersPanel',
        components: {FilterBox},
        mixins: [MediaQueryMixin],
        computed: {
            locale() {
                return this.$i18n.locale
            },
            groupsFirstLevel() {
                return this.groups.filter(group => group.parent_id === null)
            }
        },
        data: () => ({
            groups: [],
            filters: {
                searchText: '',
                groupsSelected: [],
            }
        }),
        mounted() {
            this.loadGroups();
        },
        watch: {
            filters: {
                handler(val) {
                    this.$emit('change', val);
                },
                deep: true
            }
        },
        methods: {
            async loadGroups() {
                try {
                    this.groups = await LayersService.fetchGroups();
                    this.groups = ArrayUtils.orderByKey(this.groups, `title_${this.locale}`);
                } catch (e) {
                    console.error('Error cargando los grupos...');
                    console.error(e);
                }
            },
            updateFilter(groupId) {
                const index = this.filters.groupsSelected.indexOf(groupId);

                if (index > -1) {
                    this.filters.groupsSelected.splice(index, 1);
                } else {
                    this.filters.groupsSelected.push(groupId);
                }
            },
            clearFilters() {
                this.filters = {
                    searchText: '',
                    groupsSelected: [],
                };
            }
        }
    }
</script>

<style lang="scss">
  .list-group-item {
    font-size: 0.9rem;
    padding: 0.4rem 1rem;
  }

  .filters-header {
    h4, button {
      display: inline-block;
      vertical-align: middle;
    }

    button {
      float: right;
    }
  }
</style>